import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import UserService from '../../../Services/userService';

export default class CreditMemoSearchParams extends SearchParamsBase {
  initialize() {
    this.SelectedOfficeIds = OfficeHelper.GetDefaultOfficeIds(parseInt(UserService.GetOfficeIdOfLoggedInUser()));
    this.ClientName = '';
    this.ClientId = '';
    this.CreditMemoId = '';
    this.ClientInvoiceId = '';
    this.CreatedBy = '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'ClientName', label: 'Client Name', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-6', type: InputTypesEnum.UserSelect },
    { fieldName: 'ClientId', label: 'Client ID', className: 'col-6', type: InputTypesEnum.Number },
    { fieldName: 'CreditMemoId', label: 'Credit Memo ID', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'ClientInvoiceId', label: 'Client Invoice ID', className: 'col-6', type: InputTypesEnum.Number },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'CreditMemoSearchParams';
  static maxWidth = 1000;
}
